import types from '../types';

const initialState = {
    jwtAccessToken: '',
    tasks: [],
    induivalTaskInfo:'',
    taskListItems:[],
    taskStakeHolderList: [],
    taskInfo: [],
    taskStatusList: []

};

const taskReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_USER_JWT:
            return {
                ...state,
                jwtAccessToken: action.payload,
            };
        case types.RESET_CONFIGURATOR_STATE:
            return {
                ...initialState,
            };
        case types.SET_TASKINFO_DATA:
            const { tasks } = action.payload;
            return {
            ...state,
                tasks,
            }; 
        case types.SET_INDUIVALTASK_DATA:
            const { induivalTaskInfo } = action.payload;
            return {
                ...state,
                induivalTaskInfo,
            };

        case types.SET_TASKLISTITEM_DATA:
            const { taskListItems } = action.payload;
            return {
                ...state,
                taskListItems,
            };

        case types.SET_GET_TASK_STAKE_HOLDERS:
            const { taskStakeHolderList } = action.payload;
            return {
                ...state,
                taskStakeHolderList,
            };
        case types.SET_GET_TASK_LIST:
            const { taskList } = action.payload;
            return {
                ...state,
                taskList,
            };
        case types.SET_TASK_STATUS:
            const { taskStatusList } = action.payload
            return {
                ...state,
                taskStatusList : taskStatusList?.response
            };
        case types.SET_SCHEDULE_MEETING:
            const{scheduleMeeting} = action?.response
            return{
                ...state,
                scheduleMeeting,
            }
        default:
            return state;
    }
};

export default taskReducer;